import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Search from './Search';

const App = () => (

    <Router>
    <div id="ContentsInner">
    <div id="Main">
        <div className="BreadCrumb">
            <p className="Gnavi"><a href="http://www.asahi.com/">朝日新聞</a></p><span>&gt;</span>
            <h1 className="Genre">サイト内記事検索結果</h1>
            <p className="LastUpdated"></p>
        </div>

        <Search />
    </div>
    <div id="Sub">
        <div id="SubInner">
        </div>
    </div>
    </div>
    </Router>
    );

export default App;
